import { render, staticRenderFns } from "./budgets.vue?vue&type=template&id=25144e28&"
import script from "./budgets.vue?vue&type=script&lang=js&"
export * from "./budgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports